import React from 'react';
import PageSeo from '@/seo/PageSeo';
import html2pdf from 'html2pdf.js';
import $ from 'jquery';
import { PrinterIcon } from '@heroicons/react/24/solid';
import { sendGAPageview } from '@/utils/gaConsent';
import AidaDisclaimerContentFromMarkdown from './AidaDisclaimerContentFromMarkdown';

export default function AidaDisclaimer() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/AIDA-disclaimer',
    title: 'AIDA Disclaimer',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'aida-disclaimer.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  return (
    <React.Fragment>
      <PageSeo
        title="AIDA Disclaimer | DISGENET"
        description="Terms of use for AIDA, the DISGENET AI assistant grounded in the gene-disease association API."
        path="/AIDA-disclaimer"
      />

      <section>
        <div className="container txt-contenido text-right">
          <button
            className="btn bg-light rounded-circle mr-12"
            onClick={downloadSummary}
            title="Download PDF"
          >
            <PrinterIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="container txt-contenido" id="printer">
          <AidaDisclaimerContentFromMarkdown />
        </div>
      </section>
    </React.Fragment>
  );
}
